import React, { useState, useEffect } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { getStaticFileUrl } from "../utils/config";

interface AboutUsData {
  title: string;
  videoUrl: string;
  description: string;
}

export const AboutUs: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [aboutUsData, setAboutUsData] = useState<AboutUsData>({
    title: 'ABOUT US',
    videoUrl: '/video/ABOUTUS영상.mp4',
    description: '재미와 공익을 동시에 충족시키는 씨유미디어그룹의 실험적 기획은\n공중파 프로그램 제작에서 이미 독보적인 영역을 개척하고 있습니다.',
  });

  useEffect(() => {
    // 서버에서 About 데이터 불러오기
    const loadAboutData = async () => {
      try {
        const { aboutApi } = await import('../services/api');
        const data = await aboutApi.getAboutData();
        if (data.aboutUs) {
          setAboutUsData(data.aboutUs);
        }
      } catch (error) {
        console.error('About 데이터 로드 실패:', error);
      }
    };
    loadAboutData();
  }, []);

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        height: isMobile ? "55vh" : "90vh",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "rgb(0, 0, 0)",
        paddingTop: "2.5rem", // 40px
        marginBottom: "1.25rem", // 20px
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      {/* 제목 */}
      <Typography
        variant="h2"
        sx={{
          fontSize: isMobile ? "1.9rem" : "2.75rem",
          fontWeight: "700",
          marginBottom: "0.625rem", // 10px
          color: "#E23C3C",
          display: "block",
        }}
      >
        {aboutUsData.title}
      </Typography>

      {/* 중앙 영상 */}
      <Box
        sx={{
          width: isMobile ? "90%" : "42.5%",
          aspectRatio: "16 / 9",
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "0.5rem", // 8px
          overflow: "hidden",
          boxShadow: "0px 1.875rem 1.25rem rgba(0, 0, 0, 0.3)", // 30px 20px
        }}
      >
        <video
          width="100%"
          height="100%"
          controls
          autoPlay
          muted
          loop
          style={{
            objectFit: "cover",
            borderRadius: "0.5rem",
          }}
        >
          <source src={getStaticFileUrl(aboutUsData.videoUrl)} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* 설명 텍스트 */}
      <Typography
        sx={{
          fontSize: isMobile ? "1.1rem" : "1.5rem",
          paddingTop: isMobile ? "2.5rem" : "3.75rem", // 40px : 60px
          display: "block",
          textAlign: "center",
        }}
      >
        {aboutUsData.description.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < aboutUsData.description.split('\n').length - 1 && <br />}
          </React.Fragment>
        ))}
      </Typography>
    </Box>
  );
};
